import {COUNTRY_CODES} from '@/utils/constants/countryConstants'
import {ThemeProvider as NewThemeProvider} from '@pepsico-ds/ui'
import {ThemeProvider as LegacyThemeProvider} from 'pepsico-ds'
import {useEffect} from 'react'

const DEFAULT_NEW_THEME = 'Dark PepsiConnect'
const DEFAULT_LEGACY_THEME = 'Dark Peacock'

let isNewThemeCssLoaded = false

export const MarketThemeProvider = ({market = COUNTRY_CODES.MX, children}) => {
  useEffect(() => {
    if (market === COUNTRY_CODES.US && !isNewThemeCssLoaded) {
      import('./newThemeCss').then(() => {
        isNewThemeCssLoaded = true
      })
    }
  }, [market])

  console.log('MarketThemeProvider: ', market)

  const ThemeProviderComponent = market === COUNTRY_CODES.US ? NewThemeProvider : LegacyThemeProvider
  const defaultTheme = market === COUNTRY_CODES.US ? DEFAULT_NEW_THEME : DEFAULT_LEGACY_THEME

  return <ThemeProviderComponent defaultStyle={defaultTheme}>{children}</ThemeProviderComponent>
}

export default MarketThemeProvider
